import React, { useEffect, useState } from "react";
import SidebarNav from "../Sidebar/SidebarNav.js";
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis, Pie, PieChart } from "recharts";
import { Card } from "react-bootstrap";
import chartsService from "../../../services/chartsService.js";
import LoadingContent from "../../public/LoadingContent.js";
import { decodeJWT, getCurrentToken } from "../../../helpers/accessTokenHelper.js";
import DashboardAdmin from "./DashboardAdmin.js";
import projectsService from "../../../services/projectsService.js";
import customDataService from "../../../services/customDataService.js";

const Dashboard = () => {
    const [tasksByStatus, setTasksByStatus] = useState([]);
    const [tasksByUsers, setTasksByUsers] = useState([]);
    const [tasksByCustomData, setTasksByCustomData] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [loading, setLoading] = useState(true);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);

    //Red ciudad Joven
    const [dataSetProject, setDataSetProject] = useState([]);
    const [projectData, setProjectData] = useState([]);
    const loadProjects = () => {
        projectsService.getProjects().then(data => {
            setProjectData(data);
        });
    };
    const percentChartData = dataSetProject.flatMap(entry =>
        entry.group.custom_fields
            .filter(field =>
                field.field_type === "percent" &&
                typeof field.value === "string" &&
                field.value.includes("%")
            )
            .map(field => {
                const cleaned = field.value.replace(",", ".").replace("%", "").trim();
                const percent = parseFloat(cleaned);
                return {
                    name: field.field_name,
                    percent: isNaN(percent) ? 0 : percent,
                    color: "#17a2b8"
                };
            })
    );
    //Red ciudad Joven

    let loadedCount = 0;

    useEffect(() => {
        setLoading(true);

        //Red ciudad Joven
        loadProjects();
        //Red ciudad Joven

        const token = getCurrentToken();
        if (token !== "") {
            const data = decodeJWT(token);
            if (data) {
                if (data.data.name === "SystemDefaultSuperAdmin") {
                    setIsSuperAdmin(true);
                }
            }
        }

        const today = new Date();
        const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayThisMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        const start_date = firstDayLastMonth.toISOString().split("T")[0];
        const end_date = lastDayThisMonth.toISOString().split("T")[0];
        setStartDate(start_date);
        setEndDate(end_date);

        GetTasksCountGroupedByStatus(start_date, end_date);
        GetTasksCountGroupedByUsers(start_date, end_date);
        GetTasksCountByCustomData(start_date, end_date);
    }, []);

    //Red ciudad Joven
    useEffect(() => {
        try {
            if (projectData.length > 0) {
                projectData.forEach((item) => {
                    if (item.project_name === "Red Ciudad Joven"){
                        let groupIds = [];
                        let rawValues = [];
                        try {
                            groupIds = JSON.parse(item.custom_fields_groups) || [];
                            rawValues = JSON.parse(item.custom_fields_data_values) || [];

                            customDataService.getCustomDataGroupsForSelectables().then((allGroups) => {
                                try {
                                    const selected = allGroups.filter(g => groupIds.includes(g.id));
                                    const combined = selected.map(group => {
                                        const entry = rawValues.find(v => v.groupId === group.id);
                                        return { group, values: entry ? entry.values : {} };
                                    });
                                    setDataSetProject(combined);
                                } catch (error) { console.log(error)}
                            });
                        } catch (error) { console.log(error)}
                    }
                })
            }
        } catch (error) { console.log(error)}
    }, [projectData]);
    //Red ciudad Joven

    const getRandomColor = () => {
        return '#' + Math.floor(Math.random() * 16777215).toString(16);
    };

    const GetTasksCountGroupedByStatus = (start_date, end_date) => {
        chartsService.getTasksCountGroupedByStatus(start_date, end_date).then(data => {
            const tasks = [];
            if (data && data.length > 0) {
                data.forEach(item => {
                    tasks.push({
                        name: item.Status,
                        Tareas: item.Tasks,
                        color: item.Color
                    });
                });
            }
            setTasksByStatus(tasks);
            loadedCount++;
            if (loadedCount === 3) {
                setLoading(false);
            }
        });
    }

    const GetTasksCountGroupedByUsers = (start_date, end_date) => {
        chartsService.getTasksCountGroupedByUsers(start_date, end_date).then(data => {
            const tasks = [];
            if (data.success) {
                try {
                    data.data.forEach(item => {
                        tasks.push({
                            name: item.User,
                            Tareas: item.Tasks,
                            color: getRandomColor()
                        });
                    });
                } catch (e){}
            }
            setTasksByUsers(tasks);
            loadedCount++;
            if (loadedCount === 3) {
                setLoading(false);
            }
        });
    }

    const GetTasksCountByCustomData = (start_date, end_date) => {
        chartsService.getTasksCountByCustomData(start_date, end_date).then(data => {
            try {
                const coloredData = data.map(category => ({
                    ...category,
                    results: category.results.map(result => ({
                        ...result,
                        color: getRandomColor()
                    }))
                }));
                setTasksByCustomData(coloredData);
            } catch {}
            loadedCount++;
            if (loadedCount === 3) {
                setLoading(false);
            }
        });
    }

    const loadCustomFields = () => {
        setLoading(true);
        projectsService.getProjects().then(data => {
            setLoading(false);

        });
    }

    const handleFilter = () => {
        setLoading(true);
        GetTasksCountGroupedByStatus(startDate, endDate);
        GetTasksCountGroupedByUsers(startDate, endDate);
        GetTasksCountByCustomData(startDate, endDate);
    }

    if (isSuperAdmin) {
        return <DashboardAdmin />;
    } else {
        return (
            <div className="container-fluid" style={{background: 'url(/waves-white.png)'}}>
                <div className="row vh-100">
                    <SidebarNav />

                    <div className="col-md-9 col-lg-10 p-4 content-container">

                        {loading && <LoadingContent />}

                        {!loading && (
                            <>
                                <h3 className="mb-4">Dashboard</h3>

                                <div className="row card-inputs bg-gradient-reverse">
                                    <div className="col col-3">
                                        <label htmlFor="start_date" className="form-label">Fecha Inicio</label>
                                        <input className="form-control" name="start_date" id="start_date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                    </div>
                                    <div className="col col-3">
                                        <label htmlFor="end_date" className="form-label">Fecha Fin</label>
                                        <input className="form-control" name="end_date" id="end_date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                                    </div>
                                    <div className="col col-3">
                                        <button className="btn btn-success" style={{ marginTop: '30px' }} onClick={() => handleFilter()}>Filtrar</button>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col col-4">
                                        <Card className="shadow-sm" style={{ marginTop: '50px' }}>
                                            <Card.Header className="bg-gradient-reverse text-white">
                                                <h5 className="mb-0">Tareas por estado</h5>
                                            </Card.Header>
                                            <Card.Body>
                                                {tasksByStatus.length > 0 ? (
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <BarChart data={tasksByStatus}>
                                                            <XAxis
                                                                dataKey="name"
                                                                angle={-45}
                                                                textAnchor="end"
                                                                interval={0}
                                                                tick={{ fontSize: 12 }}
                                                                height={100} />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Bar dataKey="Tareas">
                                                                {tasksByStatus.map((entry, index) => (
                                                                    <Cell key={`cell-status-${index}`} fill={entry.color} />
                                                                ))}
                                                            </Bar>
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                ) : (
                                                    <p>No hay datos disponibles</p>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </div>

                                    <div className="col col-4">
                                        <Card className="shadow-sm" style={{ marginTop: '50px' }}>
                                            <Card.Header className="bg-gradient text-white">
                                                <h5 className="mb-0">Tareas por usuarios asignados</h5>
                                            </Card.Header>
                                            <Card.Body>
                                                {tasksByUsers.length > 0 ? (
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <BarChart data={tasksByUsers}>
                                                            <XAxis
                                                                dataKey="name"
                                                                angle={-45}
                                                                textAnchor="end"
                                                                interval={0}
                                                                tick={{ fontSize: 12 }}
                                                                height={100} />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Bar dataKey="Tareas">
                                                                {tasksByUsers.map((entry, index) => (
                                                                    <Cell key={`cell-user-${index}`} fill={entry.color} />
                                                                ))}
                                                            </Bar>
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                ) : (
                                                    <p>No hay datos disponibles</p>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </div>

                                    {tasksByCustomData?.length > 0 ? (
                                        tasksByCustomData.map((entry, index) => (
                                            <div key={index} className="col col-4">
                                                <Card className="shadow-sm" style={{ marginTop: '50px' }}>
                                                    <Card.Header className="bg-secondary text-white">
                                                        <h5 className="mb-0">{entry.category}</h5>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        {entry.results.length > 0 ? (
                                                            <ResponsiveContainer width="100%" height={300}>
                                                                <BarChart data={entry.results}>
                                                                    <XAxis
                                                                        tickFormatter={(name) =>
                                                                            name.length > 24 ? `${name.slice(0, 24)}...` : name
                                                                        }
                                                                        dataKey="title"
                                                                        angle={-45}
                                                                        textAnchor="end"
                                                                        interval={0}
                                                                        tick={{ fontSize: 12 }}
                                                                        height={100} />
                                                                    <YAxis />
                                                                    <Tooltip />
                                                                    <Bar dataKey="tasks">
                                                                        {entry.results.map((res, idx) => (
                                                                            <Cell key={`cell-custom-${idx}`} fill={res.color} />
                                                                        ))}
                                                                    </Bar>
                                                                </BarChart>
                                                            </ResponsiveContainer>
                                                        ) : (
                                                            <p>No hay datos disponibles</p>
                                                        )}
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        ))
                                    ) : (
                                        <></>
                                    )}

                                    {percentChartData.length > 0 && (
                                        <div className="col col-12">
                                            <Card className="shadow-sm" style={{ marginTop: "50px", minWidth: '100%' }}>
                                                <Card.Header className="bg-secondary text-white card-header-yellow">
                                                    <h5 className="mb-0">Indicadores (%)</h5>
                                                </Card.Header>
                                                <Card.Body>
                                                    <ResponsiveContainer width="100%" height={40 * percentChartData.length}>
                                                        <BarChart layout="vertical" data={percentChartData}>
                                                            <XAxis
                                                                type="number"
                                                                domain={[0, 100]}
                                                                tickFormatter={(v) => `${v}%`}
                                                            />
                                                            <YAxis
                                                                type="category"
                                                                dataKey="name"
                                                                width={160}
                                                                tick={{ fontSize: 12 }}
                                                            />
                                                            <Tooltip formatter={(v) => `${v}%`} />
                                                            <Bar dataKey="percent">
                                                                {percentChartData.map((entry, index) => (
                                                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                                                ))}
                                                            </Bar>
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </Card.Body>
                                            </Card>
                                        </div>
                                    )}

                                    {Array.isArray(dataSetProject) && dataSetProject.length > 0 && (
                                        <>
                                            <div className="col col-4">
                                                <Card className="shadow-sm" style={{ marginTop: '50px' }}>
                                                    <Card.Header className="bg-secondary text-white card-header-cyan">
                                                        <h5 className="mb-0">Tasa de % Juventudes</h5>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <ResponsiveContainer width="100%" height={300}>
                                                            <PieChart>
                                                                {dataSetProject.map((entry, index) => {
                                                                    const raw = (entry.values["760894e6-47f2-4395-9830-eddd203da510"] || "0")
                                                                        .replace(",", ".").replace("%", "").trim();
                                                                    const value = parseFloat(raw) || 0;
                                                                    const data = [
                                                                        { name: 'Porcentaje', value },
                                                                        { name: 'Restante', value: 100 - value }
                                                                    ];
                                                                    return (
                                                                        <Pie
                                                                            key={`pie-${index}`}
                                                                            data={data}
                                                                            dataKey="value"
                                                                            nameKey="name"
                                                                            cx="50%"
                                                                            cy="50%"
                                                                            outerRadius={100}
                                                                            label
                                                                        >
                                                                            <Cell fill="#17a2b8" />
                                                                            <Cell fill="#e9ecef" />
                                                                        </Pie>
                                                                    );
                                                                })}
                                                                <Tooltip formatter={(v) => `${v}%`} />
                                                            </PieChart>
                                                        </ResponsiveContainer>
                                                    </Card.Body>
                                                </Card>
                                            </div>

                                            <div className="col col-4">
                                                <Card className="shadow-sm" style={{ marginTop: '50px' }}>
                                                    <Card.Header className="bg-secondary text-white card-header-orange">
                                                        <h5 className="mb-0">Tasa de % Juventudes Regional</h5>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <ResponsiveContainer width="100%" height={300}>
                                                            <PieChart>
                                                                {dataSetProject.map((entry, index) => {
                                                                    const raw = (entry.values["03ac8953-e258-4fc0-b9bf-7b1da8ce4312"] || "0")
                                                                        .replace(",", ".").replace("%", "").trim();
                                                                    const value = parseFloat(raw) || 0;
                                                                    const data = [
                                                                        { name: 'Porcentaje', value },
                                                                        { name: 'Restante', value: 100 - value }
                                                                    ];
                                                                    return (
                                                                        <Pie
                                                                            key={`pie2-${index}`}
                                                                            data={data}
                                                                            dataKey="value"
                                                                            nameKey="name"
                                                                            cx="50%"
                                                                            cy="50%"
                                                                            outerRadius={100}
                                                                            label
                                                                        >
                                                                            <Cell fill="#ffc107" />
                                                                            <Cell fill="#e9ecef" />
                                                                        </Pie>
                                                                    );
                                                                })}
                                                                <Tooltip formatter={(v) => `${v}%`} />
                                                            </PieChart>
                                                        </ResponsiveContainer>
                                                    </Card.Body>
                                                </Card>
                                            </div>

                                            <div className="col col-4">
                                                <Card className="shadow-sm" style={{ marginTop: '50px' }}>
                                                    <Card.Header className="bg-secondary text-white card-header-purple">
                                                        <h5 className="mb-0">Desempleo Juvenil, ENE (%)</h5>
                                                    </Card.Header>
                                                    <Card.Body>
                                                        <ResponsiveContainer width="100%" height={300}>
                                                            <PieChart>
                                                                {dataSetProject.map((entry, index) => {
                                                                    const raw = (entry.values["cf3cc4aa-1eb9-41da-b300-36c19ee98068"] || "0")
                                                                        .replace(",", ".").replace("%", "").trim();
                                                                    const value = parseFloat(raw) || 0;
                                                                    const data = [
                                                                        { name: 'Porcentaje', value },
                                                                        { name: 'Restante', value: 100 - value }
                                                                    ];
                                                                    return (
                                                                        <Pie
                                                                            key={`pie3-${index}`}
                                                                            data={data}
                                                                            dataKey="value"
                                                                            nameKey="name"
                                                                            cx="50%"
                                                                            cy="50%"
                                                                            outerRadius={100}
                                                                            label
                                                                        >
                                                                            <Cell fill="#dc3545" />
                                                                            <Cell fill="#e9ecef" />
                                                                        </Pie>
                                                                    );
                                                                })}
                                                                <Tooltip formatter={(v) => `${v}%`} />
                                                            </PieChart>
                                                        </ResponsiveContainer>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        </>
                                    )}

                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;
